require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./flutter-redux-setup.json") })
        }
      }, "path---flutter-redux-setup");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---flutter-redux-setup!./.cache/json/flutter-redux-setup.json
// module id = 384
// module chunks = 231608221292675